module.exports = __webpack_public_path__ + "static/media/COTK2_3.32f930c0.png";